<template>
  <b-container fluid>
    <b-row>
      <b-col><h4>Simple Interview</h4></b-col>
    </b-row>

    <template v-if="interviewDetails!=null">
      <b-row>
        <b-col><b>System variables</b></b-col>
      </b-row>

      <b-row v-for="vv in interviewDetails.systemVariables" :key="vv.variableName">
        <b-col>{{vv.variableName}}: {{vv.value}}</b-col>
      </b-row>

      <b-row>
        <b-col><b>Question variables</b></b-col>
      </b-row>

      <b-row v-for="vv in interviewDetails.questionVariables" :key="vv.variableName">
        <b-col>{{vv.variableName}}: {{vv.value}}</b-col>
      </b-row>

      <b-row>
        <b-col><b>Computed variables</b></b-col>
      </b-row>

      <b-row v-for="vv in interviewDetails.computedVariables" :key="vv.variableName">
        <b-col>{{vv.variableName}}: {{vv.value}}</b-col>
      </b-row>

    </template>

  </b-container>
</template>

<script>
import {mapGetters, mapState} from "vuex";

export default {
  name: 'SimpleInterviewComponent',

  props: {
    interviewDetails: Object
  },

  components: {
    // Widget, ViewPathWidget
  },

  computed: {
    ...mapState(['activeSurvey', 'absoluteDrillPath']),
    ...mapGetters(['realmName', 'studyName', 'authToken', 'pageByName', 'completePath']),

  },

}
</script>